import { apiConfig } from './ApiConfig';
import { isObject } from 'lodash';

/**
 * 
 * @param {*} url 
 * @param {*} headers 
 */
export const get = (url, headers) => {
  if (headers && !Array.isArray(headers) && isObject(headers)) {
    return apiConfig.get(url, headers);
  } else {
    return apiConfig.get(url);
  }
};

/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the post (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */
export const post = (url, params, headers) => {
  if (headers && !Array.isArray(headers) && isObject(headers)) {
    return apiConfig.post(url, { ...params }, { 'headers': headers });
  } else {
    return apiConfig.post(url, { ...params });
  }
};

/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the update (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */
export const update = (url, params, headers) => {
  if (headers && !Array.isArray(headers) && isObject(headers)) {
    return apiConfig.put(url, { ...params }, { 'headers': headers });
  } else {
    return apiConfig.put(url, { ...params });
  }
};

/**
 * 
 * @param {string} url 
 * @param {data object} params 
 * @param {object} headers - optional headers to be added to the request (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */
export const request = (url, params, headers) => {
  if (headers && !Array.isArray(headers)) {
    return apiConfig.request(url, { ...params }, { 'headers': headers });
  } else {
    return apiConfig.request(url, { ...params });
  }
};

/**
 * 
 * @param {string} url 
 * @param {object} headers - optional headers to be added to the request (i.e. audit).
 * see instance.interceptors.request.use in ApiConfig for std headers that are added by default
 */
export const remove = (url, headers) => {
  if (headers && !Array.isArray(headers)) {
    return apiConfig.delete(url, { 'headers': headers });
  } else {
    return apiConfig.delete(url);
  }
};



// WEBPACK FOOTER //
// ./services/ApiClient.js